import { Component, Input } from '@angular/core';
import { NavController, NavParams, App, ToastController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { CurrentEventProvider } from '../../providers/current-event/current-event';
import { MyEventsProvider } from '../../providers/my-events/my-events';
import { User } from '../../providers/user/user';
import { ToastHelper } from '../../helpers/toastr-helper';

@Component({
    selector: 'exhibitor',
    templateUrl: 'exhibitors.html'
})
export class ExhibitorsComponent {
    @Input()
    exhibitor: any;

    constructor(
        public app: App,
        public navCtrl: NavController,
        public navParams: NavParams,
        public http: HttpClient,
        public currentEventProvider: CurrentEventProvider,
        private myEventsProvider: MyEventsProvider,
        private userProvider: User,
        private toastCtrl: ToastController
    ) {

    }

    ngOnInit() {

    }

    viewProfile(event: any, userId: string): void {
      event.stopPropagation();
        if ( userId !== this.userProvider.currentUser().uuid) {
            this.app.getRootNav().push('ProfilePage', {
                userId: userId
            });
        }
    }

    openItem(pin: string, eventId: string, name: string) {
        this.myEventsProvider.joinEvent(eventId).subscribe(
            res => {
                this.app.getRootNav().setRoot('EventSwitchPage', {
                    pin: pin,
                    name: name
                });
            },
          err => {
            if (err.status === 409) {
              ToastHelper.Show(this.toastCtrl, err.error.message, 2000)
            }
          }
        );
    }

    viewExhibitorDetails(exhibitor: any): void {
        this.app.getRootNav().push('PerformerProfilePage', {
            exhibitor: exhibitor
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/exhibitors/exhibitors.ts